module.exports = __webpack_public_path__ + "img/img8.5d8188db.svg";